import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const CATALOG_SPINNERET_ENDPOINT = 'catalog-spinnerets';
export const CATALOG_SPINNERET_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CATALOG_SPINNERET_ENDPOINT);

export const catalogSpinneretStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}
